import { useGraphQLQuery } from '@betterment/graphql';
import { Route, Routes, useSearchParams } from 'react-router-dom';

import { AccountAgreements } from './components/AccountAgreements';
import { ConfirmAccount } from './components/ConfirmAccount';
import { Error } from './components/Error';
import { Loading } from './components/Loading';
import { SignDocument } from './components/SignDocument';
import { Success } from './components/Success';
import {
  AdvisedSoloPlanInvitationDocument,
  AdvisedSoloPlanInvitationQuery,
} from './graphql/query.advisedSoloPlanInvitation.generated';

import { WithLayout } from '../RetailApp/components/WithLayout';

export default function Controller() {
  const [params] = useSearchParams();
  const { data, loading, error } = useGraphQLQuery<AdvisedSoloPlanInvitationQuery>(AdvisedSoloPlanInvitationDocument, {
    variables: { token: params.get('invitation_token') },
  });

  if (loading) {
    return <Loading />;
  }

  if (error || !data?.advisedSoloFourOhOneKClientInvite) {
    return <Error />;
  }

  const { advisor } = data.advisedSoloFourOhOneKClientInvite;

  if (advisor.__typename !== 'InstitutionalAdvisor' || !advisor.firm) {
    return <Error />;
  }

  const { firm } = advisor;
  const firmName = firm.name;
  const clientAgreementUrl = firm.defaultClientAgreementUrl;
  const clientAgreementToken = firm.defaultClientAgreementToken;

  return (
    <WithLayout parts={{ footer: true, sidebar: false }}>
      <Routes>
        <Route
          path="/confirm_account"
          element={
            <ConfirmAccount
              logoUrl={data.advisedSoloFourOhOneKClientInvite.advisor.logo?.light}
              isSoloFourOhOneKPlanOwner={data.advisedSoloFourOhOneKClientInvite.isSoloFourOhOneKPlanOwner}
            />
          }
        />
        {data.advisedSoloFourOhOneKClientInvite.isSoloFourOhOneKPlanOwner && (
          <Route
            path="/sign_document"
            element={
              <SignDocument
                logoUrl={data.advisedSoloFourOhOneKClientInvite.advisor.logo?.light}
                signablePackage={data.advisedSoloFourOhOneKClientInvite.signablePackage}
              />
            }
          />
        )}
        <Route
          path="/account_agreements"
          element={
            <AccountAgreements
              logoUrl={data.advisedSoloFourOhOneKClientInvite.advisor.logo?.light}
              firmName={firmName}
              clientAgreementUrl={clientAgreementUrl}
              clientAgreementToken={clientAgreementToken}
            />
          }
        />
        <Route path="/success" element={<Success />} />
      </Routes>
    </WithLayout>
  );
}
